<template>
  <div
    class="navbarItemMobile"
    :class="{ activeMobile: isActive }"
    @click="onHandleClick()"
  >
    <div class="iconItem">
      <b-icon pack="fas" :icon="icon"></b-icon>
    </div>
    <span class="name">
      {{ this.name }}
    </span>
  </div>
</template>
<script>
export { openNav };
export default {
  props: {
    icon: {
      type: String
    },
    name: {
      type: String
    },
    collapsed: {
      type: Boolean
    },
    to: {
      type: String
    }
  },
  data() {
    return {
      isActive: false,
      openNav: true
    };
  },
  created() {
    if (this.$router.currentRoute.path === this.to) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  },
  methods: {
    onHandleClick() {
      if (this.$router.currentRoute.path != this.to) {
        this.$router.push({ path: this.to });
        this.$store.state.activeGroup = this.name;
      }
      this.openNav = !this.openNav;
    }
  },
  watch: {
    $route({ path }, from) {
      if (path === this.to) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    }
  }
};
</script>
<style scoped>
.activeMobile::after {
  content: "";
  position: absolute;
  left: 0;
  width: 8px;
  height: 20px;
  margin-top: 3px;
  background-color: #f56618;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.iconItem {
  padding: 0px 10px 0px 0px;
}
.navbarItemMobile {
  color: white;
  width: 100%;
  cursor: pointer;
  padding-bottom: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  transition: color 0.2s;
  transition: padding 0.2s;
  padding-left: 15px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/navbarMobile/navbarItem.vue